// src/prompts.ts
// Gentle writing prompts, so nobody has to stare at a blank page.

// For letters to a pen pal.
export const LETTER_PROMPTS = [
  "What's something small that made you happy this week?",
  "Tell them about a place that feels like home to you.",
  "What are you reading, watching, or listening to lately?",
  "Describe the view from where you're sitting right now.",
  "What's a food that tastes like comfort to you?",
  "What's something you're learning, or want to learn?",
  "Tell them about someone who made you feel seen.",
  "What does a really good day look like for you?",
  "What song is stuck in your head, and why do you love it?",
  "What's a tiny ritual that gets you through hard days?",
  "Tell them about a hobby you could talk about for hours.",
  "What's something about your culture or family you're proud of?",
  "What would you tell your younger self, if you could send them a letter?",
  "What's the weather like where you are, and how does it make you feel?",
  "Ask them a question you've always wanted someone to ask you.",
  ...QUESTIONS(),
];

// Questions that work in a letter or a board post. Our own, written for
// this community: nothing about gender roles, bodies, or religion assumed.
function QUESTIONS() {
  return [
    // getting to know you
    "If you had to talk for fifteen minutes about anything, what would you pick?",
    "What's something you're quietly, wonderfully nerdy about?",
    "Do you have a hidden talent, or a very specific skill nobody asks about?",
    "What's a nickname you love, or one you've grown out of?",
    "How would your closest friends describe you in three words?",
    "What do people get wrong about you at first?",
    "What's an opinion you hold that most people don't?",
    "Are you more of a night owl or a morning person, and why?",
    "What's your favorite way to spend a free afternoon?",
    "What's a word or phrase you say all the time?",
    // comfort and care
    "What does rest look like for you when you really get it?",
    "What's your coziest outfit or most comforting object?",
    "Who or what helps you feel safe?",
    "What's a smell that instantly makes you feel at home?",
    "How do you like to be cared for when you're having a rough day?",
    "What's something that reliably makes you laugh?",
    "What's a small act of kindness you still think about?",
    "What helps you on low-spoon days?",
    "What does your ideal slow morning look like?",
    "Where do you go, in your head or for real, when you need peace?",
    // memories
    "What's a song that takes you straight back to a certain year?",
    "What's a favorite memory with a friend?",
    "What did you love doing as a kid that you'd like to do again?",
    "What's the best gift you've ever been given?",
    "Tell me about a time you felt really proud of yourself.",
    "What's a moment you realized you were becoming more yourself?",
    "What's the most beautiful place you've ever been?",
    "What's a tradition, old or new, that means a lot to you?",
    // the everyday
    "What does a normal week look like for you right now?",
    "What's the view out the nearest window?",
    "What's in your bag or on your desk right now?",
    "Where do you usually write, and what's around you?",
    "Do you write all at once or a little at a time?",
    "What's your go-to snack, comfort meal, or drink?",
    "Coffee, tea, hot cocoa, or something else entirely?",
    "What's the best thing you've eaten lately?",
    "What chore do you secretly enjoy, and which do you dread?",
    "What's something in your home you love looking at?",
    "Do you live somewhere busy, quiet, or in between? What do you like about it?",
    "What season fits you best, and what do you love and dread about it?",
    // what you love
    "What's a book, show, or movie you'd recommend to anyone?",
    "Who's an artist, writer, or musician who makes you feel understood?",
    "What's a song you've had on repeat lately?",
    "Do you make art, crafts, music, or anything with your hands?",
    "What's your favorite animal, real or mythical?",
    "If you could take any class just for fun, what would it be?",
    "What's a hobby you've always wanted to try?",
    "Which fictional world would you most like to live in?",
    "What's a queer or trans story, book, or film that mattered to you?",
    // hopes and big feelings
    "What's something you're looking forward to?",
    "What's one thing you'd change about the world if you could?",
    "What does community mean to you?",
    "Who are some people, past or present, you look up to?",
    "What do you hope your life looks like in a few years?",
    "What's something you're working on letting go of?",
    "What are a few things you're grateful for right now?",
    "What's a dream you haven't told many people?",
    "What makes you feel most like yourself?",
    "If you could share one meal with anyone, past or present, who would it be?",
    // just for fun
    "If you could travel anywhere for free tomorrow, where would you go?",
    "Describe your dream home, as cozy or as wild as you like.",
    "Beach, forest, mountains, or city?",
    "Pineapple on pizza: yes, no, or it's complicated?",
    "Do numbers, letters, or days of the week have colors or personalities for you?",
    "What's a weird food combination you swear by?",
    "If you had a tiny shop, what would it sell?",
    "What would your theme song be?",
    "If you were a plant, what kind would you be and why?",
    "What's the last thing that made you laugh out loud?",
  ];
}

// For a first post on the board, introducing yourself.
export const BOARD_PROMPTS = [
  "Start with three things you love and one thing you're curious about.",
  "What kind of pen pal are you hoping to find?",
  "How often do you like to write? Fast replies, slow letters, whenever spoons allow?",
  "What would you love to talk about in your first few letters?",
  "Describe yourself the way a good friend would.",
  "What's on your mind lately, big or small?",
  "Share a song, a snack, and a place that feel like you.",
  "What do you hope a pen pal brings to your life right now?",
];

// The board's post form: intro ideas first, then the questions.
export const POST_PROMPTS = [...BOARD_PROMPTS, ...QUESTIONS()];

// The home page's prompt of the week: the same one for everyone, changing
// every Monday.
export function promptOfTheWeek(now = new Date()) {
  const week = Math.floor((now.getTime() / 86400000 + 3) / 7); // weeks since a Monday
  return LETTER_PROMPTS[week % LETTER_PROMPTS.length];
}
